import { TREATMENT_SERVICE_PREFIXES } from './constants';

import type {
  ITreatmentPlanV3TreatmentPage,
  TreatmentPagePatch,
  TreatmentPlanV3TreatmentPagePayload,
} from './types';

export function applyTreatmentPagePatch(
  page: ITreatmentPlanV3TreatmentPage,
  payload: ITreatmentPlanV3TreatmentPage,
  data: TreatmentPlanV3TreatmentPagePayload,
) {
  page.id = payload.id;
  page.therapy_provisioning_description = payload.therapy_provisioning_description;
  if ('recommendations_explanation' in data) {
    page.recommendations_explanation = payload.recommendations_explanation;
  }
  if ('proposed_start_date' in data) {
    page.proposed_start_date = payload.proposed_start_date;
  }
  if ('duration_in_months' in data) {
    page.duration_in_months = payload.duration_in_months;
  }
  for (const prefix of TREATMENT_SERVICE_PREFIXES) {
    const line = payload.services[prefix];
    if (!line) continue;
    const current = { hours: null, units: null, per: null, ...page.services[prefix] };
    if (`${prefix}_hours` in data) {
      current.hours = line.hours;
      current.units = line.units;
    }
    if (`${prefix}_per` in data) {
      current.per = line.per;
    }
    page.services[prefix] = current;
  }
}

export function mergeTreatmentPagePatches(
  page: ITreatmentPlanV3TreatmentPage,
  patches: TreatmentPagePatch[],
) {
  const merged = { ...page, services: { ...page.services } };
  for (const patch of patches) {
    applyTreatmentPagePatch(merged, patch.payload, patch.data);
  }
  return merged;
}
